<template>
  <div class="wrap">

    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">


      <!-- form-title-wrap -->
      <div class="form-title-wrap">
        <form-title :tip="tip" :flag="flag" :tip3="tip3"></form-title>
      </div>
      <!-- form-title-wrap -->



      <ul class="tab-title clearfix">
          <li :class="{ active: showFunc=='username' }"  @click="tabShowFunc('username')"  >用户名</li>
          <li :class="{ active: showFunc=='psnid' }" @click="tabShowFunc('psnid')" >身份证</li>
      </ul>
      <div class="edit-form">

        <div class="edit-form-wrap" >
          <el-form
            :model="editForm"
            :rules="rules"
            ref="editForm"
            label-width="100px"
            class="form"
          >

            <el-form-item label="用户名" prop="username"  v-show="showFunc=='username'" >
              <el-input
                v-model="editForm.username"
                placeholder="请填写注册时的用户名"
                clearable
              />
            </el-form-item>



            <el-form-item label="身份证" prop="psnid"  v-show="showFunc=='psnid'" >
              <el-input
                v-model="editForm.psnid"
                placeholder="请填写身份证"
                clearable
              />
            </el-form-item>
            


            <div class="server-code-wrap" >
              <el-form-item label="动态码" class="code-input"  prop="validcode">
                <el-input
                    v-model="editForm.validcode"
                    clearable
                  />
              </el-form-item>

              <div class="code-btn-wrap">
                <el-button
                  type="warning"
                  @click="getCode"
                  :disabled="!disabledCodeBtn"
                >
                  获取验证码
                </el-button>
                <span v-show="!show" class="count">
                  {{ count }}秒后可再次发送
                </span>
              </div>

            </div>



            <el-form-item label="新密码" prop="password">
              <el-input
                type="password"
                v-model="editForm.password"
                placeholder="密码长度在6-20位字符之间"
              />
            </el-form-item>
            <el-form-item label="确认新密码" prop="password2">
              <el-input
                type="password"
                v-model="editForm.password2"
                placeholder="请重新输入一下新的密码"
              />
            </el-form-item>

            <div class="form-opts" >
              <el-button type="primary" @click="submit('editForm')">
                保存
              </el-button>
              <el-button type="info"  @click="backLogin()" >
                取消
              </el-button>
            </div>

        </el-form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import formTitle from '../common/formTitle';
import { sendValidCode, newPwd } from '../request/regAndEdit';
import { Message } from 'element-ui';



export default {
  name: 'forget-passwd',
  components: {
    formTitle
  },
  data() {
    
    //密码验证
    let checkPassword = (rule, value, callback) => {

      // 是否包含一位数字
      // const regNumber = /(?=.*[\d])/
      // // 是否包含一位字母
      // const regLetter = /(?=.*[a-zA-Z])/
      // // 是否包含一位特殊字符
      // const regCharacter = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
      if (!value || value == '') {
        callback(new Error('密码不能为空!'));
        return;
      } 
      if (value.length > 20 || value.length < 6) {
          callback(new Error('密码长度为6-20位!'));
          return;
      }

      // if (!regNumber.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      // if (!regLetter.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      // if (!regCharacter.test(value)) {
      //   callback(new Error('密码必须由数字，英文字母和特殊字符组成!'));
      //   return;
      // }

      callback()
    }

    //确认密码
    let checkPassword2 = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请重复输入密码'));
        return;
      }  
      if (value !== this.editForm.password) {
        callback(new Error('两次输入密码不一致'));
        return;
      }
      callback()
    }


    // 用户名和身份证
    let checkId = (rule, value, callback) => {
      if(this.showFunc != 'psnid') {
        // 不验证当前的
        callback()
      }
      if (!value || value === '') {
        callback(new Error('请填写身份证!'));
        return;
      }  
      callback()
    }

    let checkUsername = (rule, value, callback) => {
      if(this.showFunc != 'username') {
        // 不验证当前的
        callback()
      }
      if (!value || value === '') {
        callback(new Error('请填写用户名!'));
        return;
      }  
      callback()
    }



    return {
      showFunc: 'username',
      editForm: {
        // 用户名
        username: '',
        // 身份证
        psnid: '',
        // 验证码
        validcode: '',
        // 密码
        password: '',
        password2: ''
      },

      show: true,
      disabledCodeBtn: true,
      count: '',
      timer: null,
      // serverCode: '',

      tip: '找回密码',
      tip3: '温馨提示: 请填写注册时的用户名, 邮件会发送到该用户名下的邮箱',
      flag: true,
      rules: {
        username: [
          { required: true, validator: checkUsername, trigger: 'blur' }
        ],
        psnid: [
          { required: true, validator: checkId, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: checkPassword, trigger: 'blur' }
        ],
        password2: [
          { required: true, validator: checkPassword2, trigger: 'blur' }
        ],
        validcode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }



    }
  },
  methods: {
    tabShowFunc(showFunc){
      this.showFunc = showFunc;
    },
    //修改完成提交
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 验证码
          // if(!this.serverCode 
          // || this.serverCode == '' 
          // || this.serverCode != this.editForm.validcode) {
          //     Message({
          //           type: 'warning',
          //           message: '验证码错误'
          //      });
          //     return;
          // }

          this.newPwd()
        } else {
          return false
        }
      })
    },

    //获取验证码
    getCode() {

      
      if(this.showFunc == 'psnid') {
        if(!this.editForm.psnid || this.editForm.psnid == '') {
          Message({
              type: 'warning',
              message: '请填写身份证!'
          });
          return;
        }
      }
      if(this.showFunc == 'username') {
        if(!this.editForm.username || this.editForm.username == '') {
          Message({
              type: 'warning',
              message: '请填写注册时的用户名!'
          });
          return;
        }
      }

      

      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
            this.disabledCodeBtn = false
          } else {
            this.show = true
            this.disabledCodeBtn = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }

      let psnid = this.editForm.psnid;
      let username = this.editForm.username;

      if(this.showFunc != 'psnid') {
        psnid = '';
      } else if(this.showFunc != 'username') {
        username = '';
      }

      let params = {
        username: username,
        psnid: psnid,
        type: 'email'
      }
      sendValidCode(params).then(res => {
        if (res.success) {
            
            Message({
                type: 'success',
                message: res.message
            });

            // this.serverCode = res.data.validcode;

        } else {

            Message({
                type: 'warning',
                message: res.message
            });

        }
      })
    },

    //新密码
    newPwd() {

      let psnid = this.editForm.psnid;
      let username = this.editForm.username;

      if(this.showFunc != 'psnid') {
        psnid = '';
      } else if(this.showFunc != 'username') {
        username = '';
      }

      let params = {
        username: username,
        newpwd: this.editForm.password,
        psnid: psnid,
        validcode: this.editForm.validcode,
        type: "email"
      }

      let toLoginPage = function() {
        this.$router.push('/login');
      }.bind(this);

      newPwd(params).then(res => {

        if (res.success) {
            
          Message({
              type: 'success',
              message: res.message,
              duration: 1000*3,
              onClose: toLoginPage
          });

        } else {

          Message({
                type: 'warning',
                message: res.message,
                duration: 1000*3
          });

        }

      });

    },
    backLogin() {
      this.$router.push({'name': 'login'});
    }

  },
  mounted() {}
}
</script>

<style lang="scss" scoped>





.wrap {

  .wrapper {
    width: auto;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 24px;
    padding-bottom: 40px;
  }

  .form-title-wrap {
    line-height: 40px;
    margin-bottom: 12px;
  }

  .edit-form {
    margin: 0 auto;
    background: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 12px;
    padding-top: 24px;
    
    border-left: 1px solid #0089D0;
    border-right: 1px solid #0089D0;
    border-bottom: 1px solid #0089D0;
  }

  .tab-title {
    border-bottom: 1px solid #0089D0;
    
    height: 40px;
    line-height: 40px;
    z-index: 10;

    li {
      float: left;
      padding: 0 12px;
      background: #fff;
      height: 40px;
      line-height: 40px;
      min-width: 120px;
      text-align: center;
      margin-right: 12px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      z-index: 9;
      cursor: pointer;
      border: 1px solid #fff;
      border-bottom: 1px solid #0089D0;
      margin-bottom: -1px;

      &.active {
        border-bottom: 1px solid #fff;
        border-left: 1px solid #0089D0;
        border-top: 1px solid #0089D0;
        border-right: 1px solid #0089D0;
      }
      
    }
  }

  .edit-form-wrap {
      margin: 0 auto;
  }

  .form-opts {
    text-align: center;
  }


::v-deep {

  .server-code-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;

    .code-input {
      flex: auto;
    }

    .code-btn-wrap {
      flex: 0 0 auto;
      margin-left: 12px;
    }

    .el-form-item {
      margin-bottom: 0;
    }
    


  }

}



}



@media screen and (min-width: 320px) { 

}

@media screen and (min-width: 480px) { 
    
}
/* 移动 */
@media screen and (min-width: 576px) { 
    
}
/* 平板 */
@media screen and (min-width: 768px) { 

}

/* PC */
@media screen and (min-width: 992px) {

}
@media screen and (min-width: 1200px) {

  .wrap {

    .wrapper {
      width: 1200px;
      padding-left: 0;
      padding-right: 0;
    }


  }

}






</style>
